import Vue from 'vue';
import Popper from 'popper.js';
import BootstrapVue from 'bootstrap-vue';

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.use(BootstrapVue);
